// src/js/utils/helpers.js

/**
 * Formaterar ett nummer till svensk valuta (SEK).
 */
export const formatter = {
    format: function(price) {
        const isEnglish = document.documentElement.lang.startsWith('en');
        const formattedNumber = new Intl.NumberFormat('sv-SE', { 
            minimumFractionDigits: 0, 
            maximumFractionDigits: 0 
        }).format(price);
        
        return isEnglish ? `${formattedNumber}\u00A0SEK` : `${formattedNumber}\u00A0kr`;
    }
};

/**
 * Escapar HTML-tecken i en sträng för att förhindra XSS.
 * @param {string} str Den osäkra strängen.
 * @returns {string} En säker sträng.
 */
export function escapeHTML(str) {
    const p = document.createElement('p');
    p.textContent = str;
    return p.innerHTML;
}

/**
 * Läser av CSS-transitionens varaktighet för ett element.
 * @param {HTMLElement} element Elementet att mäta.
 * @param {string} propertyName CSS-egenskapen (t.ex. 'opacity').
 * @returns {number} Varaktigheten i millisekunder.
 */
export function getTransitionDurationMs(element, propertyName) {
    if (!element) return 0;
    // ... (Din befintliga logik för denna funktion är bra och behålls)
    const computedStyle = getComputedStyle(element);
    const transitionProperties = computedStyle.getPropertyValue('transition-property').split(',').map(prop => prop.trim());
    const transitionDurations = computedStyle.getPropertyValue('transition-duration').split(',').map(duration => duration.trim());

    let durationMs = 0;
    const propertyIndex = transitionProperties.indexOf(propertyName);

    if (propertyIndex !== -1 && transitionDurations[propertyIndex]) {
        const cssDurationString = transitionDurations[propertyIndex];
        if (cssDurationString.endsWith('s')) {
            durationMs = parseFloat(cssDurationString) * 1000;
        } else if (cssDurationString.endsWith('ms')) {
            durationMs = parseFloat(cssDurationString);
        } else {
            durationMs = parseFloat(cssDurationString) || 0;
        }
    }
    return durationMs;
}

/**
 * Uppdaterar CSS-klassen för dynamisk breakpoint baserat på fönsterbredd.
 */
export function updateDynamicBreakpoint() {
    // Denna funktion behöver tillgång till DOM-element. Vi hämtar dem direkt här.
    const formGrid = document.getElementById('form-grid');
    const output = document.getElementById('output');
    const showConfigurationTable = document.getElementById('show-configuration-table');
    
    if (!formGrid) return; // Gör inget om huvudelementet inte finns

    let dynamicBreakpoint = 736; // Standardvärde

    if (output && showConfigurationTable) {
        const outputVisible = getComputedStyle(output).display !== 'none';
        const tableVisible = getComputedStyle(showConfigurationTable).display !== 'none';
        if (outputVisible && tableVisible) {
            dynamicBreakpoint = 1096;
        } else if (outputVisible) {
            dynamicBreakpoint = 816;
        }
    }
    
    const currentWindowWidth = window.innerWidth;
    if (currentWindowWidth < dynamicBreakpoint) {
        formGrid.classList.add('breakpoint-small');
    } else {
        formGrid.classList.remove('breakpoint-small');
    }
}


/**
 * Jämnar ut höjden på panel-headers.
 */
export function equalizePanelHeaderHeights() {
    const leftPanelHeader = document.querySelector('.left-panel .panel-header');
    const rightPanelHeader = document.querySelector('.right-panel .panel-header');

    if (leftPanelHeader && rightPanelHeader) {
        leftPanelHeader.style.height = 'auto';
        rightPanelHeader.style.height = 'auto';

        const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);

        const leftPaddingTop = parseFloat(getComputedStyle(leftPanelHeader).paddingTop);
        const leftPaddingBottom = parseFloat(getComputedStyle(leftPanelHeader).paddingBottom);
        const rightPaddingTop = parseFloat(getComputedStyle(rightPanelHeader).paddingTop);
        const rightPaddingBottom = parseFloat(getComputedStyle(rightPanelHeader).paddingBottom);

        const leftTotalPadding = leftPaddingTop + leftPaddingBottom;
        const rightTotalPadding = rightPaddingTop + rightPaddingBottom;

        const leftContentHeightPx = leftPanelHeader.offsetHeight - leftTotalPadding;
        const rightContentHeightPx = rightPanelHeader.offsetHeight - rightTotalPadding;

        const maxContentHeightPx = Math.max(leftContentHeightPx, rightContentHeightPx);

        leftPanelHeader.style.height = `${maxContentHeightPx / rootFontSize}rem`;
        rightPanelHeader.style.height = `${maxContentHeightPx / rootFontSize}rem`;
    }
}